// PostHog project region (US cloud). The project API key is public (it ships in
// the browser bundle) and is injected per app; see docs/DEPLOY.md.
export const POSTHOG_HOST = 'https://us.i.posthog.com';
export const POSTHOG_ASSET_HOST = 'https://us-assets.i.posthog.com';
export const POSTHOG_UI_HOST = 'https://us.posthog.com';

/** First-party path on the web Worker that relays to PostHog (apps/web `src/worker.ts`). */
export const POSTHOG_INGEST_PATH = '/ingest';

export type AnalyticsApp = 'api' | 'web' | 'admin' | 'company';
